import { Reveal } from "./ui";

const marqueeTags = [
  "内娱热点",
  "新剧上线",
  "舞台名场面",
  "票房盘点",
  "转会内幕",
  "新歌榜单",
  "红毯造型",
  "赛事复盘",
  "综艺名场面",
  "海外联动",
];

export default function CtaBanner() {
  return (
    <section className="overflow-hidden bg-background-50 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg border border-background-200">
            {/* 暖色底纹，不用图片，保持克制 */}
            <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-100" />
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-accent-200/60 blur-2xl" />
            <div className="relative flex flex-col items-start gap-8 p-8 md:flex-row md:items-center md:justify-between md:p-12">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-semibold text-primary-800">
                  <i className="ri-compass-3-line" /> cg51 栏目导航
                </span>
                <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                  别在多平台之间来回翻了，<br />热门讨论从这里一页掌握。
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                  从热点专楼到吃瓜合集、从分区盘点再到话题大全，按兴趣挑一条路进去，剩下的交给 cg51。
                </p>
                <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                  <a href="#topics" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
                    去话题大全看看 <i className="ri-arrow-right-line" />
                  </a>
                  <a href="#top" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300">
                    <i className="ri-arrow-up-line" /> 回到顶部
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* 跑马灯热词 */}
        <Reveal className="mt-6">
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100 py-3">
            <div className="cg-marquee flex w-max items-center gap-8">
              {[...marqueeTags, ...marqueeTags].map((tag, i) => (
                <span key={i} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-foreground-600">
                  <i className="ri-flashlight-line text-accent-600" /> {tag}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}